import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error:   "group-[.toaster]:!bg-destructive   group-[.toaster]:!text-white group-[.toaster]:!border-destructive   [&_[data-description]]:!text-white/80",
          success: "group-[.toaster]:!bg-emerald-500   group-[.toaster]:!text-white group-[.toaster]:!border-emerald-500   [&_[data-description]]:!text-white/80",
          warning: "group-[.toaster]:!bg-amber-500    group-[.toaster]:!text-white group-[.toaster]:!border-amber-500    [&_[data-description]]:!text-white/80",
          info:    "group-[.toaster]:!bg-blue-500     group-[.toaster]:!text-white group-[.toaster]:!border-blue-500     [&_[data-description]]:!text-white/80",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
